import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
@Pipe({
  name: 'customcurrencyZAR'
})
export class ZARCurrencyPipe implements PipeTransform {
  transform(
    value: number,
    currencyCode: string = 'ZAR',
    display: 'code' | 'symbol' | 'symbol-narrow' | string | boolean = 'symbol',
    digitsInfo: string = '3.2-2',
    locale: string = 'en'
  ): string | null {
    return formatCurrency(value, locale, getCurrencySymbol(currencyCode, 'narrow'), currencyCode, digitsInfo);
  }
}
